<template>
  <span
    :class="[
      'tag',
      { tooltip: tooltipTitle && type === 'outgoing' },
      { downloaded: receiver.filesSent && type === 'outgoing' },
      { error: receiver.failed }
    ]"
    :tooltip-title="tooltipText"
  >
    <!--TODO use slot-->
    <span class="status-icon"></span>
    <human-icon width="11px" height="12px" cssClass="person"></human-icon>
    <span>{{ receiver.email | emailName }}</span>
  </span>
</template>

<script>
import HumanIcon from "@/components/icons/HumanIcon";

export default {
  name: "EmailTag",
  components: {
    HumanIcon
  },
  props: {
    tooltipTitle: {
      default: false
    },
    type: {
      required: true
    },
    receiver: {
      required: true
    }
  },
  computed: {
    tooltipText() {
      const errorMessage = this.receiver.failed
        ? this.$t("is-not-registered")
        : "";
      return `${this.tooltipTitle.email}${errorMessage}`;
    }
  }
};
</script>

<style lang="scss">
@import "../assets/styles/variables";

html .tag.tooltip:before {
  transform: translateX(-50%) translateY(-33px);
}

html .tag.tooltip:after {
  top: -8px;
}

.tag,
.ti-tag {
  border-radius: $radius !important;
  background-color: #eff3f6 !important;
  color: inherit !important;
  padding: 5px 10px !important;
  font-size: inherit !important;
  margin: 5px;
  position: relative;
  display: inline-block;
  svg.person {
    margin-right: 5px;
  }
  &.ti-invalid {
    background-image: none;
    background-color: transparent !important;
    padding: 5px 10px !important;
    color: $error-color !important;
  }
  &:not(.ti-tag) {
    border: 1px solid #cfd1d3;
  }
}

.tag {
  .status-icon {
    width: 15px;
    height: 15px;
    position: absolute;
    display: block;
    top: 0;
    right: 0;
    border-radius: 100%;
    transform: translateY(-5px) translateX(5px);
  }
  &.downloaded {
    .status-icon {
      background: $success-color
        url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB3aWR0aD0iOXB4IiBoZWlnaHQ9IjlweCI+PHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTE3My44OTggNDM5LjQwNGwtMTY2LjQtMTY2LjRjLTkuOTk3LTkuOTk3LTkuOTk3LTI2LjIwNiAwLTM2LjIwNGwzNi4yMDMtMzYuMjA0YzkuOTk3LTkuOTk4IDI2LjIwNy05Ljk5OCAzNi4yMDQgMEwxOTIgMzEyLjY5IDQzMi4wOTUgNzIuNTk2YzkuOTk3LTkuOTk3IDI2LjIwNy05Ljk5NyAzNi4yMDQgMGwzNi4yMDMgMzYuMjA0YzkuOTk3IDkuOTk3IDkuOTk3IDI2LjIwNiAwIDM2LjIwNGwtMjk0LjQgMjk0LjQwMWMtOS45OTggOS45OTctMjYuMjA3IDkuOTk3LTM2LjIwNC0uMDAxeiIvPjwvc3ZnPg==)
        no-repeat center center;
    }
  }
  &.error {
    .status-icon {
      background: $error-color;
    }
  }
}

.ti-selected-item,
.ti-deletion-mark {
  background-color: darken(#eff3f6, 5%) !important;
}
</style>
